enum VerticalAlignmentEnum {
	base = 'base',
	super = 'super'
}

export default VerticalAlignmentEnum;
